export const EVENT_COLOR_DEFAULT = '#DFF3E4';

export const SCHEDULE_MODE_FULL = 'full';
export const SCHEDULE_MODE_MYSELF = 'myself';

export const DEFAULT_VIEW_MODE = 'month';
